import React from 'react';
import { Card, Row, Col, Typography, List, Space, Tag } from 'antd';
import { 
  RocketOutlined, 
  StarOutlined, 
  GlobalOutlined, 
  BulbOutlined, 
  HeartOutlined, 
  TrophyOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const MissionValues = () => {
  const values = [
    {
      title: 'Excellence',
      icon: <TrophyOutlined style={{ color: '#52c41a' }} />,
      description: 'Nous nous engageons à offrir une formation de haute qualité, basée sur des connaissances pratiques et concrètes. Notre équipe de formateurs, experts dans leur domaine, s\'efforce de maintenir les normes les plus élevées pour aider nos apprenants à exceller dans leur carrière.',
      color: '#52c41a'
    },
    {
      title: 'Accessibilité',
      icon: <GlobalOutlined style={{ color: '#1890ff' }} />,
      description: 'Nous croyons que l\'information devrait être accessible à tous. Nous nous efforçons donc de proposer des cours abordables et flexibles, permettant aux apprenants de trouver leur propre espace pour apprendre où et quand ils le souhaitent.',
      color: '#1890ff'
    },
    {
      title: 'Innovation',
      icon: <BulbOutlined style={{ color: '#faad14' }} />,
      description: 'Nous sommes constamment à la recherche de nouvelles façons d\'améliorer notre plateforme éducative, en intégrant les dernières technologies et les meilleures pratiques pédagogiques. Nous cherchons à repousser les limites de l\'apprentissage en ligne pour offrir une expérience toujours plus enrichissante.',
      color: '#faad14'
    },
    {
      title: 'Engagement envers nos apprenants',
      icon: <HeartOutlined style={{ color: '#f5222d' }} />,
      description: 'Nous plaçons nos apprenants au cœur de tout ce que nous faisons. Nous sommes déterminés à les soutenir tout au long de leur parcours d\'apprentissage, en leur offrant un encadrement personnalisé et des ressources complètes pour les aider à atteindre leurs objectifs professionnels.',
      color: '#f5222d'
    },
    {
      title: 'Impact positif',
      icon: <RocketOutlined style={{ color: '#722ed1' }} />,
      description: 'Nous croyons en l\'impact positif de la formation sur la vie des individus et la société dans son ensemble. Nous aspirons à être un catalyseur de changement, en formant des professionnels compétents et talentueux qui contribuent au progrès et au développement de leur domaine d\'expertise.',
      color: '#722ed1'
    }
  ];

  return (
    <div className="mission-values-page" style={{ padding: '20px 0' }}>
      <div className="container">
        {/* Mission Section */}
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              <StarOutlined /> Mission et Valeurs
            </Title>
          </div>

          {/* Notre Mission */}
          <Card 
            style={{ 
              marginBottom: '30px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white'
            }}
            bodyStyle={{ padding: '40px' }}
          >
            <Title level={2} style={{ color: 'white', textAlign: 'center', marginBottom: '20px' }}>
              <RocketOutlined /> Notre Mission
            </Title>
            <Paragraph style={{ 
              fontSize: '18px', 
              lineHeight: '1.8', 
              textAlign: 'justify', 
              color: 'white',
              margin: 0
            }}>
              Chez Nomidya, notre mission est de fournir une expérience d'apprentissage en ligne de qualité supérieure, offrant à nos apprenants du monde entier l'accès à des cours de pointe dans les domaines de SAP et de la gestion de projets. Nous visons à inspirer, former et accompagner chaque individu dans son parcours d'apprentissage, en lui offrant les compétences essentielles pour réussir dans le monde professionnel en constante évolution.
            </Paragraph>
          </Card>

          {/* Nos Valeurs */}
          <Card style={{ background: '#f0f2f5' }}>
            <Title level={2} style={{ color: '#1890ff', textAlign: 'center', marginBottom: '30px' }}>
              <StarOutlined /> Nos Valeurs
            </Title>
            
            <Row gutter={[24, 24]}>
              {values.map((value, index) => (
                <Col xs={24} md={12} lg={8} key={index}>
                  <Card 
                    hoverable
                    style={{ 
                      height: '100%',
                      borderTop: `4px solid ${value.color}`,
                      transition: 'all 0.3s ease'
                    }}
                    bodyStyle={{ padding: '24px' }}
                  >
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                          {value.icon}
                        </div>
                        <Title level={4} style={{ color: value.color, margin: 0 }}>
                          {value.title}
                        </Title>
                      </div>
                      <Paragraph style={{ 
                        fontSize: '14px', 
                        lineHeight: '1.6', 
                        textAlign: 'justify',
                        margin: 0
                      }}>
                        {value.description}
                      </Paragraph>
                    </Space>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>

          {/* Message de conclusion */}
          <Card style={{ 
            marginTop: '30px', 
            textAlign: 'center',
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            color: 'white'
          }}>
            <Title level={3} style={{ color: 'white', marginBottom: '20px' }}>
              <CheckCircleOutlined /> Construisons Ensemble l'Avenir
            </Title>
            <Paragraph style={{ 
              fontSize: '16px', 
              lineHeight: '1.8', 
              color: 'white',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              Ensemble, avec nos apprenants, nous construisons un avenir où l'apprentissage transforme des vies et où les compétences ouvrent des portes vers de nouvelles opportunités. Chez Nomidya, notre mission et nos valeurs nous guident dans cette aventure passionnante de développement et de croissance professionnelle.
            </Paragraph>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default MissionValues;